import { render, staticRenderFns } from "./salon.vue?vue&type=template&id=badb7e20&scoped=true&"
import script from "./salon.vue?vue&type=script&lang=js&"
export * from "./salon.vue?vue&type=script&lang=js&"
import style0 from "./salon.vue?vue&type=style&index=0&id=badb7e20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "badb7e20",
  null
  
)

export default component.exports